/**
 * Array that contains special cases for markets
 */
export const noDecimalMarkets = [
  "KR", // Korea
  "JP", // Japan
  "KO", // Korea
  "TH", // Thailand
];
